import Cookies from 'js-cookie';

const userLocationCookieName = 'gd-user-region';

export const getUserRegionCode = (cb) => {
  const existingCookie = Cookies.get(userLocationCookieName);

  if (typeof existingCookie === 'string' && existingCookie.length > 0) {
    if (typeof cb === 'function') {
      cb(existingCookie);
    }
  }

  if (
    typeof window.geoip_detect === 'object' &&
    typeof window.geoip_detect.get_info === 'function'
  ) {
    window.geoip_detect.get_info().then((geo) => {
      try {
        const regionCode = geo.data.extra.original.region_code;

        regionCode && Cookies.set(userLocationCookieName, regionCode);

        if (typeof cb === 'function') {
          cb(regionCode);
        }
      } catch (e) {
        console.log(`Error geoip detect ${e}`);
      }
    });
  }
};
